module.exports = __webpack_public_path__ + "static/media/nose.e74dbd45.png";